import { render, staticRenderFns } from "./Cafeteria.vue?vue&type=template&id=739a2614"
import script from "./Cafeteria.vue?vue&type=script&lang=js"
export * from "./Cafeteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports